import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';
import { TranslatedText } from '@ianesthesie-kit/core';
import { SourceType } from '@/modules/surgicalEvent';

export const SourceTypeTooltip = ({
  sourceType,
  justification,
  children,
  ...props
}: Partial<TooltipProps> & {
  sourceType: SourceType;
  justification?: string;
}) => (
  <Tooltip
    title={
      justification ? (
        <>
          <TranslatedText id={`app.sourceType.${sourceType}`} /> -{' '}
          {justification}
        </>
      ) : (
        <TranslatedText id={`app.sourceType.${sourceType}`} />
      )
    }
    enterDelay={600}
    {...props}
  >
    <span>{children}</span>
  </Tooltip>
);
